import { render, staticRenderFns } from "./Gold.vue?vue&type=template&id=c7392552&scoped=true&"
import script from "./Gold.vue?vue&type=script&lang=js&"
export * from "./Gold.vue?vue&type=script&lang=js&"
import style0 from "./Gold.vue?vue&type=style&index=0&id=c7392552&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7392552",
  null
  
)

export default component.exports